import { clsx } from 'clsx';
import { IconCheck, IconError } from 'components/icons';

interface SectionStatusProps {
  /** Status to represent. */
  status: 'pending' | 'completed' | 'error';

  /** When status is completed, a number can be rendered instead of check icon. */
  statusValue?: number;

  /** Screen reader text for the status. Defaults to the status name. */
  label?: string;
}

export function SectionStatus({
  status,
  statusValue,
  label
}: SectionStatusProps) {
  if (status === 'completed' && !statusValue) {
    return (
      <div className="ml-auto" role="status">
        <div className="sr-only">{label ?? status}</div>
        <div aria-hidden="true">
          <IconCheck size="3xl" />
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="ml-auto" role="status">
        <div className="sr-only">{label ?? status}</div>
        <div aria-hidden="true">
          <IconError size="3xl" />
        </div>
      </div>
    );
  }

  const wrapperClasses = clsx(
    'w-[30px] h-[30px] rounded-full flex items-center justify-center',
    status === 'completed' ? 'bg-[#4A8264]' : 'bg-white'
  );

  return (
    <div className="ml-auto" role="status">
      <div className="sr-only">{label ?? status}</div>
      <div className={wrapperClasses}>
        {Boolean(statusValue) && status === 'completed' && (
          <span className="font-bold text-white">{statusValue}</span>
        )}
      </div>
    </div>
  );
}
